import { Lightning, Router } from '@lightningjs/sdk'

import DevSettings from '../../../components/DevSettings/DevSettingsMenu'
import { getColor, grey50, grey800 } from '../../../constants/colors'
import { UniNeueHeavy } from '../../../constants/fonts'
import { LEFT_SAFE_ZONE_MARGIN } from '../../../constants/general'
import { getText } from '../../../utils/dictionary'
import { DevSettingItem } from '../../../utils/settingsUtils'

export default class DeveloperSettings extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(grey800),
      collision: true,
      flex: { direction: 'row', paddingLeft: LEFT_SAFE_ZONE_MARGIN },
      Title: {
        y: 48,
        flexItem: { marginRight: LEFT_SAFE_ZONE_MARGIN },
        text: {
          text: getText('developerSettings'),
          fontSize: 64,
          fontFace: UniNeueHeavy,
          textColor: getColor(grey50),
          lineHeight: 72,
        },
      },
      DevSettings: {
        y: 48,
        x: 208,
        type: DevSettings,
      },
    }
  }

  get devSettings() {
    return this.tag('DevSettings') as DevSettings
  }

  _active() {
    this.widgets.forceclosewindow.visible = false
  }

  _getFocused() {
    return this.devSettings
  }

  $forceCloseApp(setting: DevSettingItem) {
    this.widgets.forceclosewindow.setting = setting
    Router.focusWidget('ForceCloseWindow')
  }
}
